import * as React from 'react';
import { connect } from 'react-redux';

import { StateType } from '../../reducers';
import { agreementsIsFetchingState } from '../../reducers/AgreementsReducer/AgreementsSelector';
import { getUserFetchingUserAgreementsSelector } from '../../reducers/AuthenticationReducer/AuthenticationSelector';
import Agreements from '../Agreements/Agreements';

interface AgreementsValidationContentProps {
  agreementsProps: Object;
}

interface AgreementsValidationContentStateToProps {
  isFetching: boolean;
  fetchingUserAgreements: boolean;
}

type genericProps = AgreementsValidationContentProps & AgreementsValidationContentStateToProps;
const AgreementsValidationContent = ({ isFetching, fetchingUserAgreements, agreementsProps }: genericProps) => {
  // `modalCloseIcon` defaults to `false` for required agreements (user / team) so users can't dismiss them,
  // but callers (e.g. competition enrollment) can opt back into showing the close icon by including
  // `modalCloseIcon: true` in `agreementsProps` — the spread placed last makes the caller's value win.
  return (
    <Agreements modalCloseIcon={false} {...agreementsProps} modalIsOpen={true} othersFetching={isFetching || fetchingUserAgreements} />
  );
};

const mapStateToProps = (state: StateType): AgreementsValidationContentStateToProps => ({
  // @ts-ignore
  isFetching: agreementsIsFetchingState(state),
  // @ts-ignore
  fetchingUserAgreements: getUserFetchingUserAgreementsSelector(state),
});

export default connect<AgreementsValidationContentStateToProps, any, any, StateType>(mapStateToProps, {})(AgreementsValidationContent);
